import { addDays, Day, startOfWeek } from 'date-fns';
import viewDaysCount from './consts';

interface GenerateRangeDaysParams {
  currentDate: Date;
  startDayOfWeek: Day;
}

export default function generateRangeDays({
  currentDate,
  startDayOfWeek,
}: GenerateRangeDaysParams) {
  const dayStart = startOfWeek(currentDate, { weekStartsOn: startDayOfWeek });
  const days = [];

  for (let day = 0; day < viewDaysCount; day++) {
    days.push(addDays(dayStart, day));
  }
  return days;
}
